import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";

export const fitsEmbedSize = (size: IEmbedSize, min: IEmbedSize): boolean =>
  size.width >= min.width && size.height >= min.height;
